<template lang="pug">
  v-container
    illustration-state.mt-12(
      v-if="!query"
      :illustration="illustrationEmpty"
      body="Vos résultats s'afficheront ici")
    v-row(v-else-if="$get(result, `length`)")
      v-col
        v-list
          v-list-item(
            v-for="({ id, name, image }) in result"
            :key="id"
            @click="onClick({ id })")
            v-list-item-avatar
              v-img(
                :src="image.src"
                :lazy-src="image.srcLazy")
            v-list-item-content {{ name }}
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
    illustration-state.mt-12(
      v-else-if="!loading"
      :illustration="illustrationNoResult"
      body="Aucun résultat")
</template>

<script>
import { page } from '@iez/core'
import illustrationEmpty from '@iez/illustrations/Searching'
import illustrationNoResult from '@iez/illustrations/Void'
import IllustrationState from '@iez/components/illustration-state/'
import router, { routeCurrent } from '@iez/core/router'
import { ref } from '@vue/composition-api'
import { mdiChevronRight, mdiMagnify } from '@mdi/js'
import data from '@iez/lib/data/'
import waitFor from '@iez/lib/wait-for/'
import { model, search } from '../'

const route = {
  name: `Search`,
  path: `/search/:query?`
}

export default {
  ...route,

  components: {
    IllustrationState
  },

  setup () {
    const loading = ref(false)
    const query = ref(``)
    const result = data.get({
      root: `users`,
      fields: [
        `id`,
        `name`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ]
        }
      ],
      request: () => ({
        where: {
          name: {
            _ilike: `%${query.value}%`
          }
        }
      }),
      waitFor: () => query.value
    })

    page.topBar.set({
      search: true
    })
    page.blockingProgression.set(
      () => loading.value
        ? {
          isActive: true
        } : null
    )

    const { params: { query: paramsQuery } } = routeCurrent

    if (paramsQuery) {
      loading.value = true
      query.value = paramsQuery
      waitFor({
        dependencies: () => result.value
      }).then(() => {
        loading.value = false
      })
    }

    const onClick = ({ id }) => {
      router.push({
        name: `Profile`,
        params: {
          id
        }
      })
    }

    page.bottomShortcut.add(
      () =>
        model.value && routeCurrent.params.query !== model.value
          ? {
            action: {
              icon: mdiMagnify,
              label: `Rechercher`,
              onClick: search
            }
          } : null
    )

    return {
      illustrationEmpty,
      illustrationNoResult,
      query,
      result,
      loading,
      mdiChevronRight,
      onClick
    }
  }
}
</script>
